import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getRadioStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  color: ${({ theme }) => theme.color.semantic.toggle.type.strong};
  transition: box-shadow 0.4s ease;

  /* Rest state */

  .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.semantic.primary.border.default};
  }

  .ant-radio-checked {
    ::after {
      border: none;
    }

    .ant-radio-inner {
      background-color: ${({ theme }) => theme.color.semantic.primary.type.default};
    }

    .ant-radio-inner::after {
      transform: scale(0.5);
      background-color: ${({ theme }) => theme.color.semantic.primary.border.default};
    }
  }

  /* Hover state */

  :hover {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.color.semantic.primary.background.default} !important;
      background-color: ${({ theme }) => theme.color.semantic.toggle.background.selected.default};
    }
  }

  /* Pressed state */

  :active {
    .ant-radio-inner {
      background-color: ${({ theme }) => theme.color.semantic.primary.background.pressedWeak};
    }
  }

  /* Disabled state */

  .ant-radio-disabled {
    .ant-radio-inner {
      border-color: ${({ theme }) => theme.color.semantic.type.disabled} !important;
      background-color: ${({ theme }) => theme.color.semantic.primary.background.disabled} !important;
    }

    .ant-radio-inner::after {
      background-color: ${({ theme }) => theme.color.semantic.type.disabled} !important;
    }
  }

  /* Focus state */

  :has(:focus-visible) {
    box-shadow: 0px 0px 0px 2px ${({ theme }) => theme.color.semantic.focus.border};
  }
`;
